<div class="modal-header border-0 py-0 px-0">
	<img [src]="bannerSrc" alt="" class="img-fluid w-100 m-0">
	<button (click)="activeModal.dismiss('Cross click')"
	        type="button"
	        aria-describedby="modal-title"
	        class="btn-close btn-close-white"
	        id="close-ad"></button>
</div>
<div class="modal-body text-center px-4">
	<h5 class="modal-title inter-bold lh-sm mb-2" id="modal-title">{{ title }}</h5>
	<p [innerHtml]="description | safeHtml" class="lh-sm mb-0"></p>
</div>
<div class="modal-footer border-0 justify-content-evenly">
	<app-outline-button [label]="denyText"
	                    (btnClick)="activeModal.dismiss('denied')"
	                    btnId="deny-ad"></app-outline-button>
	<app-filled-button [label]="acceptText"
	                   (btnClick)="activeModal.close('accepted')"
	                   btnId="accept-ad"></app-filled-button>
</div>